<template>
  <div>
    <div style="background-color:#fff">
    <!-- 其他聲明事項 -->
    <div v-for="(doc,i) in appAnnexDocList" :key="i">
      <v-expansion-panel expand
                         v-model="panel[i].switch">
        <v-expansion-panel-content>
          <template v-slot:header>
            <div class="expand-title">{{doc.annexName}}</div>
            <v-divider></v-divider>
          </template>
          <scroll-view style="height:auto!important" :id="`scroll-target${i}`">
            <v-layout>
              <pdf-viewer v-if="doc.contType === 'ANNEX' || doc.contType === 'PDF'" :cfgRatio="pdfViewerRatio" :base64Data="doc.fileCntBase64"></pdf-viewer>
              <div v-if="doc.contType === 'HTML'" v-html="doc.reviewCont"></div>
            </v-layout>
          </scroll-view>
        </v-expansion-panel-content>
        <v-btn style="min-width:500px"
               color="secondary"
               class="statement-btn"
               :disabled="disabled[i]"
               @click="done(doc, i)">
          <v-icon left
                  dark
                  v-if="doneCheck[i]">done</v-icon>
          本人已閱讀並同意以上聲明
        </v-btn>
      </v-expansion-panel>
    </div>
    </div>
    <base-btn>
      <btn-lg-default @click="preStepHandler">上一步</btn-lg-default>
      <!--<btn-lg-primary :disabled="isPreview" @click="nextStepHandler">連到APP</btn-lg-primary> -->
      <btn-lg-primary :disabled="!(isPreview || doneCheckPass)" @click="nextStepHandler">下一步</btn-lg-primary>
    </base-btn>
  </div>
</template>
<script>
import ScrollView from '@/components/Base/ScrollView'
import pdfViewer from '@/components/PDFViewer/PDFViewer.vue'
import store from '@/store'
import { withDebounce } from '@/utils'
import { createNamespacedHelpers } from 'vuex'
import ProposalStepsBase from './ProposalStepsBase'
const { mapActions } = createNamespacedHelpers('ins')
export default {
  extends: ProposalStepsBase,
  components: { ScrollView, pdfViewer },
  data () {
    return {
      cusInfoTypeO: {},
      appAnnexDocList: [],
      pdfList: [],
      scrollList: [],
      offsetTop: [],
      disabled: [],
      doneCheck: [],
      doneCheckPass: false,
      panel: [],
      insPoliciesReview: {
        transCode: '',
        docCode: '',
        docVersion: ''
      },
      pdfRate: null,
      nextDisabled: false,
      policiesInfo: {}
    }
  },
  computed: {
    pdfViewerRatio () {
      if (!this.pdfRate) {
        this.getPdfRate()
      }
      return this.pdfRate
    },
    insHighAgeLimit () {
      // 高齡年齡限制(ADM_PARMD-S01)
      let { parameterValue: limit } = this.insParameters['HIGH_AGE_LIMIT']
      limit = parseInt(limit)
      return limit
    },
    insAppTime () {
      // APP提醒時間(ADM_PARMD-S01)
      let { parameterValue: limit, variableDesc: desc } = this.insParameters['APP_REMIND_TIME']
      limit = parseInt(limit)
      return {limit, desc}
    }
  },
  beforeRouteEnter (to, from, next) {
    const { transCode } = to.params.propKey
    const reqCusInfo = store.dispatch('ins/fetchCusInfo', { transCode, cusType: ['O'] })
    const reqStatement  = store.dispatch('common/fetchAllStatement', { transCode: transCode, isPreview: false })
    const reqPoliciesInfo = store.dispatch('ins/fetchInsPoliciesInfo', { transCode })
    Promise.all([ reqCusInfo, reqStatement, reqPoliciesInfo ]).then(r => {
      const [ rCusInfo, rStatement, rPoliciesInfo ] = r
      next(vm => {
        const data = rStatement.data
        if (data.length > 0) {
          vm.pdfList = []
          vm.scrollList = []
          vm.offsetTop = []
          vm.appAnnexDocList = data
          let number = 0
          vm.appAnnexDocList.forEach(e => {
            vm.scrollList.push('#scroll-target' + number)
            vm.offsetTop.push(0)
            vm.$set(vm.disabled, number, !!vm.isPreview)
            vm.$set(vm.doneCheck, number, false)
            vm.$set(vm.panel, number, { switch: [true] })
            number++
          })
        }
        vm.cusInfoTypeO = rCusInfo.data.cusList[0]
        vm.policiesInfo = rPoliciesInfo.data
      })
    })
  },
  methods: {
    ...mapActions([ 'fetchJumpApp' ]),
    done (val, index) {
      this.insPoliciesReview.docCode = val.annexCode
      this.insPoliciesReview.docVersion = val.annexVersion
      this.insPoliciesReview.transCode = this.transCode
      this.insPoliciesReview.isStep = 'Y'
      const action = this.$api.put('/ins/common/insPoliciesReview', this.insPoliciesReview).then(res => {
        this.doneCheck[index] = true
        this.doneCheckPass = true
        this.$set(this.panel, index, { switch: [false] })
        this.$emit('go-top')
        this.$postUserAccessLog({ progClassName: 'statement_agree', methodName: '本人已閱讀並同意以上聲明(個資同意書)', stepCode: this.tabStep })
      })
      this.$commitAction({ action })
    },
    getPdfRate () {
      let lst = this.$store.getters['common/systemParam']({
        parameterType: 'INS',
        toObject: true
      })
      let { parameterValue: val } = lst['STATEMENT_PRESENT']
      let rate = parseInt(val) / 100.00
      this.pdfRate = rate.toString()
    },
    preStepHandler () {
      this.$postUserAccessLog({ progClassName: 'statement_prev', methodName: '上一步', stepCode: this.tabStep })
      this.$preStepHandler()
    },
    nextStepHandler: withDebounce(function () {
     const { doneCheck } = this
     const vm = this
     if (this.isPreview) { // 檢視要保書狀態
        //fix: Issue #98267 ， 其他聲明事項 的 下一步 紀錄 PROG_CLASSNAME 命為 'statement_next'
        this.$postUserAccessLog({ progClassName: 'statement_next', methodName: '下一步', stepCode: this.tabStep, transCode: this.transCode })
        this.$nextStepHandler()
      } else {
        let check = doneCheck.some(item => item === false)
        if (check) { // (1)檢核每份聲明的「本人已閱讀並同意以上聲明」是否皆已勾選
          this.$alert('請閱讀並審閱聲明文件')
          return
        }
        this.$setTabDone(this.tabStep, true )
        //fix: Issue #83807，其他聲明事項按下一步 相關處理遺漏修正
        const { transCode, appAnnexDocList } = this
        let appAnnexDocBody = {
          transCode: transCode,
          cusCode: '',
          appAnnexDocList: appAnnexDocList
        }
        if (appAnnexDocBody.appAnnexDocList) { // 將 PDF base64 字串資料移除避免非必要上傳
          let docList = appAnnexDocBody.appAnnexDocList
          docList.forEach(r => { r.annexContBase64 = '' })
        }
        appAnnexDocBody.cusCode = this.cusInfoTypeO.cusCode

        this.$api.post('/ins/common/insPoliciesRecords', appAnnexDocBody).then(() => {
          //fix: Issue #98267 ， 其他聲明事項 的 下一步 紀錄 PROG_CLASSNAME 命為 'statement_next'
          this.$postUserAccessLog({ progClassName: 'statement_next', methodName: '下一步', stepCode: this.tabStep, transCode: this.transCode })
          //fix by Issue #91821 , 移除多餘的 [跳轉保險公司] 呼叫
          vm.$nextStepHandler()
        })

        // 檢核前面頁籤必填項目是否皆已填寫
        /*
        let errMsg = ''
        this.tabList.forEach(item => {
          if (item.show && item.validateNum > 0) {
            errMsg += item.name + '/'
          }
        })
        if (errMsg.length > 0) {
          this.$alert('請檢視' + errMsg.slice(0, -1) + '頁籤，是否仍有必要未填入欄位！')
          return
        }else{
           this.$setTabDone(this.tabStep, true )
           this.$nextStepHandler()
        }
        */
      }

    }),
    nextStepHandler2: withDebounce(function () {
      const { transCode, appAnnexDocList, doneCheck } = this
      let appAnnexDocBody = {
        transCode: transCode,
        cusCode: '',
        appAnnexDocList: appAnnexDocList
      }
      if (this.isPreview) { // 檢視要保書狀態
        this.$postUserAccessLog({ progClassName: 'statement_app', methodName: '下一步', stepCode: this.tabStep, transCode: this.transCode })
        this.$nextStepHandler()
      } else {
        let check = doneCheck.some(item => item === false)
        if (check) { // (1)檢核每份聲明的「本人已閱讀並同意以上聲明」是否皆已勾選
          this.$alert('請閱讀並審閱聲明文件')
          return
        }
        // 檢核前面頁籤必填項目是否皆已填寫
        let errMsg = ''
        this.tabList.forEach(item => {
          if (item.show && item.validateNum > 0) {
            errMsg += item.name + '/'
          }
        })
        if (errMsg.length > 0) {
          this.$alert('請檢視' + errMsg.slice(0, -1) + '頁籤，是否仍有必要未填入欄位！')
          return
        }
        let msg = []
        msg.push('進入保險公司則不可再異動基本資料，若需異動可退回網頁重新複製調整後再進件，行動投保同意書需以新案號列印給客戶簽署，採遠距投保時，請複製案件重新調整後再進入保險公司')
        msg.push('若繳款人非要/被保險人且為高齡者(65歲以上)，請先完成保險公司高齡錄音取得錄音編號')
        msg.push('若保戶欲投保之商品同時有躉繳及分期繳，採分期繳者請於保險公司商品選擇時留意挑有數字的如 APKSPL02')
        if (this.cusInfoTypeO.insureAge > this.insHighAgeLimit) {
          msg.push('您進件之要保人為高齡，請確認是否已於保險公司完成高齡錄音並記下錄音編號(進入APP時需填寫)')
        }
        if (new Date().getHours() >= this.insAppTime.limit) {
          msg.push('目前已逾' + this.insAppTime.desc + '，因進件保險公司APP僅能同日12小時內完成(不得跨日)，請務必確認今日晚上可完成APP流程及客戶簽名，以避免需隔日重來。')
        }
        let list = []
        let num = 1
        msg.forEach(el => {
          el = '(' + num + ')'  + el
          num++
          list.push(el)
        })
        this.$confirm('<div style="text-align:left">' + list.join('<br>') + '</div>', yn => {
          if (yn) {
            this.$store.dispatch('ins/updatePolState', ({ transCode , polState: 'O' }))
            if (appAnnexDocBody.appAnnexDocList) { // 將 PDF base64 字串資料移除避免非必要上傳
              let docList = appAnnexDocBody.appAnnexDocList
              docList.forEach(r => { r.annexContBase64 = '' })
            }
            appAnnexDocBody.cusCode = this.cusInfoTypeO.cusCode
            const secAction = this.$api.post('/ins/common/insPoliciesRecords', appAnnexDocBody).then(() => {
              this.fetchJumpApp({ transCode,compCode: this.compCode, insAcceptNo: this.policiesInfo.insAcceptNo }).then(r => {
                this.$postUserAccessLog({ progClassName: 'statement_app', methodName: '下一步', stepCode: this.tabStep, transCode: this.transCode })
                // window.location.replace(url)
                const { url } = r.data
                window.open(url, '_blank') // 跳轉保險公司
                this.$router.replace({ name: 'proposal' })
              })
            })
            this.$commitAction({ action: secAction })
          }
        })

      }
    })
  }

}
</script>
<style lang="stylus" scoped>

.expand-title {
  border-bottom: 2px solid #ededed;
  padding: 8px 0px 18px;
}

.statement-btn {
  font-size: $font-size-md;
  font-weight: bolder;
  color: #fff;
}
</style>
